import angular from 'angular';
import _ from 'underscore';

import template from './showroom-settings-filters-labels.html';

class ShowroomSettingsFiltersLabels {
  public selectedLabels;
  public trackingCategory: string;
  public trackingAction: string;
  public trackingLabels;
  public isShowroomSelfServeV2Enabled: boolean;

    // Bindings
  public onLabelsChanged;
  public startingLabels;

  constructor(
        private LabelsService,
        private SessionVarsService,
        private ShowroomService,
    ) { }

  public onLabelAdded = () => {
    this.onLabelsChanged(this.selectedLabels);
  }

  public onLabelRemoved = () => {
    this.onLabelsChanged(this.selectedLabels);
  }

  public onLabelSearch = (query) => {
    return this.LabelsService.getTagsByStringAsync(query, /* limit */ 500).then((resultList) => {
      return _(resultList).map((res: any) => {
        return {
          tag: res.label,
        };
      });
    });
  }

  public $onInit = () => {
    this.selectedLabels = this.startingLabels ? angular.copy(this.startingLabels) : [];
    this.isShowroomSelfServeV2Enabled = this.SessionVarsService.isFeatureEnabled('showroom_self_serve_v2');

    this.trackingCategory = this.ShowroomService.getTrackingCategory();
    this.trackingAction = this.ShowroomService.getTrackingAction();
    this.trackingLabels = {
      labelAdded: 'CuratedLabelAdded',
      labelRemoved: 'CuratedLabelRemoved',
      helpLinkClicked: (linkName) => `HelpLinkClicked=${linkName}`,
    };
  }
}

angular.module('uia').component('showroomSettingsFiltersLabels', {
  bindings: {
    onLabelsChanged: '<',
    startingLabels: '<',
  },
  template,
  controller: [
    'LabelsService',
    'SessionVarsService',
    'ShowroomService',
    ShowroomSettingsFiltersLabels,
  ],
});
